(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  const REDUCED_MOTION_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const MOBILE_HERO_VIDEO_DELAY_MS = 3000;

  const isHeroVideoVisible = (video) => {
    if (!(video instanceof HTMLVideoElement)) return false;

    const wrapper = video.closest('.hero__video-wrapper--desktop, .hero__video-wrapper--mobile');
    const target = wrapper ?? video;

    return target.offsetWidth > 0 && target.offsetHeight > 0 && getComputedStyle(target).display !== 'none';
  };

  const stripHeroVideoSourcesForMobile = (video) => {
    video.querySelectorAll('source[src]').forEach((source) => {
      if (!source.dataset.videoSource) {
        source.dataset.videoSource = source.src;
      }
      source.removeAttribute('src');
    });
  };

  const activateHeroVideoSources = (video) => {
    video.querySelectorAll('source[data-video-source]').forEach((source) => {
      if (!source.src && source.dataset.videoSource) {
        source.src = source.dataset.videoSource;
      }
    });
  };

  const revealHeroVideo = (video, poster) => {
    video.classList.add('is-loaded');
    if (poster instanceof HTMLImageElement && poster.classList.contains('hero__video-poster')) {
      poster.classList.add('is-hidden');
    }
  };

  const loadHeroVideo = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;
    if (video.dataset.heroVideoLoaded === 'true') return;

    video.dataset.heroVideoLoaded = 'true';

    const wrapper = video.closest('.hero__video-wrapper--desktop, .hero__video-wrapper--mobile');
    const poster = wrapper
      ? wrapper.previousElementSibling
      : video.parentElement?.previousElementSibling;

    activateHeroVideoSources(video);
    video.preload = 'auto';
    video.load();

    video.addEventListener(
      'loadeddata',
      () => {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(() => revealHeroVideo(video, poster)).catch(() => revealHeroVideo(video, poster));
        } else {
          revealHeroVideo(video, poster);
        }
      },
      { once: true }
    );
  };

  const loadVisibleHeroVideos = () => {
    document.querySelectorAll('.hero__video--lazy').forEach((video) => {
      if (!isHeroVideoVisible(video)) return;
      loadHeroVideo(video);
    });
  };

  const scheduleDesktopHeroVideoLoad = () => {
    const lazyVideos = document.querySelectorAll('.hero__video--lazy');
    if (!lazyVideos.length) return;

    const runLoad = () => loadVisibleHeroVideos();

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            runLoad();
            observer.disconnect();
          }
        },
        { rootMargin: '200px 0px', threshold: 0 }
      );

      lazyVideos.forEach((video) => observer.observe(video));
      return;
    }

    window.addEventListener('load', runLoad, { once: true });
  };

  const scheduleMobileHeroVideoLoad = () => {
    if (REDUCED_MOTION_MQ.matches) return;

    const lazyVideos = document.querySelectorAll('.hero__video--lazy');
    if (!lazyVideos.length) return;

    lazyVideos.forEach(stripHeroVideoSourcesForMobile);

    let hasLoaded = false;
    const runLoad = () => {
      if (hasLoaded) return;
      hasLoaded = true;
      loadVisibleHeroVideos();
    };

    const scheduleDelayedLoad = () => {
      window.setTimeout(runLoad, MOBILE_HERO_VIDEO_DELAY_MS);
    };

    const onFirstInteraction = () => {
      document.removeEventListener('touchstart', onFirstInteraction);
      document.removeEventListener('scroll', onFirstInteraction);
      scheduleDelayedLoad();
    };

    document.addEventListener('touchstart', onFirstInteraction, { once: true, passive: true });
    document.addEventListener('scroll', onFirstInteraction, { once: true, passive: true });

    if (document.readyState === 'complete') {
      scheduleDelayedLoad();
    } else {
      window.addEventListener('load', scheduleDelayedLoad, { once: true });
    }
  };

  const initHeroVideoLoading = () => {
    if (MOBILE_MQ.matches) {
      scheduleMobileHeroVideoLoad();
      return;
    }

    scheduleDesktopHeroVideoLoad();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroVideoLoading, { once: true });
  } else {
    initHeroVideoLoading();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
